import { forwardRef } from 'react';

export const TransparentInput = forwardRef<
  HTMLInputElement,
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >
>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={`px-4 py-2 w-full bg-transparent placeholder:text-gray-800 transition-colors focus:border-white text-base outline-none border border-gray-900 ${
      className ?? ''
    }`}
    {...props}
  />
));

TransparentInput.displayName = 'Input';
